import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import classNames from 'classnames';
import styles from 'components/admin/deviceDashboard/deviceEditor/DeviceSimulator.module.scss';

const ControlTierSelection = (props) => {
  const {
    isLoading,
    controlTiers,
    selectedControlTierDisplay,
    onBack,
    onNext,
    onValueChange,
    selectedControlTier,
  } = props;

  return (
    <>
      <header className={styles.header}>
        <h4>Choose your machine control tier</h4>
      </header>
      <main className={styles.main}>
        <section className={styles.section}>
          <p>Select the control tier of machine you want to pair the device to</p>
          <Autocomplete
            loading={isLoading}
            disablePortal
            id="autocomplete-choose-machine-control-tier"
            getOptionLabel={(option) => option.displayValue ?? option}
            options={controlTiers}
            sx={{ width: '300px' }}
            onChange={(event, value) => {
              onValueChange(value);
            }}
            renderInput={(params) => <TextField {...params} label="Control Tier" />}
            value={selectedControlTierDisplay}
            isOptionEqualToValue={(option, value) => option.displayValue === value}
          />
        </section>
      </main>
      <footer className={styles.footer}>
        <p className={styles.backButton} onClick={onBack}>
          Back
        </p>
        <button
          className={classNames(styles.backButton, {
            disabled: !selectedControlTier,
          })}
          disabled={!selectedControlTier}
          onClick={onNext}
        >
          Next
        </button>
      </footer>
    </>
  );
};

export default ControlTierSelection;
